<template>
  <div class="couponBox">
    <div class="couponSearch">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="优惠券名称">
          <el-input
            v-model="formInline.title"
            placeholder="优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.status" placeholder="审核状态">
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核失败" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="couponTitle">
      <div class="title">
        优惠券列表
      </div>
      <div class="button"></div>
    </div>
    <div class="couponTable">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="优惠券id" align="center" width="80">
        </el-table-column>
        <el-table-column
          prop="title"
          label="优惠券名称"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column width="100" label="类型" align="center">
          <template slot-scope="scope">{{
            goodsType(scope.row.goods_type)
          }}</template>
        </el-table-column>
        <el-table-column label="优惠方式(元)" align="center" width="150">
          <template slot-scope="scope">{{ youhuifangshi(scope.row) }}</template>
        </el-table-column>
        <el-table-column
          prop="validity"
          label="券有效期(天)"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="role"
          label="使用规则"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column label="领取使用详情" align="center" width="100">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium"
                >{{ scope.row.used_num }}/{{
                  Number(scope.row.number) - Number(scope.row.surplus_number)
                }}/{{ scope.row.number }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" align="center" width="100">
          <template slot-scope="scope">{{ status(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column label="使用状态" align="center" width="100">
          <template slot-scope="scope">{{
            useStatus(scope.row.use_status)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="创建人"
          align="center"
          width="80"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status == 0 || scope.row.status == 2"
              @click="submitExamine(scope.row)"
              >提交审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核 -->
    <el-dialog title="提示" :visible.sync="shDialog" width="30%">
      <span style="margin-right:10px">审核是否通过</span>
      <el-select @change="shChange" v-model="shValue" placeholder="请选择">
        <el-option
          v-for="item in shData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-show="isShShow"
        style="margin-top:20px"
        type="textarea"
        placeholder="请输入未通过原因"
        v-model="auditFailed"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shDialog = false">取 消</el-button>
        <el-button type="primary" @click="shFn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/knowledgeApiConfig";
export default {
  data() {
    return {
      bookDatas: "",
      isShShow: false,
      shDialog: false,
      shData: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "审核失败",
        },
      ],
      shValue: 1,
      auditFailed: "",
      couponState: [
        {
          value: 1,
          label: "待领取",
        },
        {
          value: 2,
          label: "已使用",
        },
        {
          value: 3,
          label: "已过期",
        },
        {
          value: 4,
          label: "已废止",
        },
      ],
      couponStateValue: "",
      useTableData: {},
      couponData: [],
      form: {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vipType: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      },
      form1: {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vipType: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      },
      formData: [],
      rules: {
        title: [
          { required: true, message: "请填写优惠券标题", trigger: "blur" },
        ],
        goods_type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" },
        ],
        vipType: [
          { required: true, message: "请选择会员类型", trigger: "change" },
        ],
        favourable_type: [
          { required: true, message: "请选择优惠券方式", trigger: "change" },
        ],
        satisfy: [{ required: true, message: "请填写(满)值", trigger: "blur" }],
        amount: [{ required: true, message: "请填写(减)值", trigger: "blur" }],
        discount: [{ required: true, message: "请填写折扣", trigger: "blur" }],
        number: [
          { required: true, message: "请填写发放数量", trigger: "blur" },
        ],
        user_type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        limit: [
          { required: true, message: "请填写每人限量数量", trigger: "blur" },
        ],
        validity: [
          { required: true, message: "请填写有效天数", trigger: "blur" },
        ],
      },
      // 优惠券类型
      couponType: [
        { id: 1, name: "VIP" },
        { id: 2, name: "古籍" },
      ],
      vipTypeNumber: 1,
      // 会员类型
      vipList: [],
      // 优惠方式
      preferentialMethod: [
        { id: 1, name: "满减" },
        { id: 2, name: "折扣" },
        { id: 3, name: "无门槛" },
      ],
      // 用户类型
      userTypeList: [
        { id: "all", name: "所有用户" },
        { id: "new_register", name: "仅新注册用户" },
        { id: "vip", name: "仅会员" },
        { id: "not_vip", name: "仅非会员" },
        // { id: 3, name: "复购3次" },
        // { id: 3, name: "复购10次" },
      ],
      // 是否叠加
      compositionList: [
        { id: 1, name: "可叠加" },
        { id: 2, name: "不可叠加" },
      ],
      preferentialMethodNumber: "",
      centerDialogVisible: false,
      changeDialogVisible: false,
      delDialog: false,
      userDetailDialog: false,
      abolishDialog: false,
      closeDialog: false,
      openDialog: false,
      bookDialog: false,
      formInline: {
        status: "0",
      },
      page: {
        index: 1,
        size: 10,
        total: 0,
      },
      coupon_use_detail_page: {
        index: 1,
        size: 10,
        total: 0,
      },
      bookCurrentPage: 1,
      book_totalPages: 1,
      book_pageTotal: 10,
      book_page_size: 10,
      book_page_index: 1,

      currentPage: 1,
      totalPages: 1,
      pageTotal: 10,
      page_size: 10,
      page_index: 1,
      tableData: [],
      options: [
        { value: "1", label: "域外古籍", children: [] },
        { value: "2", label: "基础古籍", children: [] },
        { value: "3", label: "孤本古籍", children: [] },
      ],
      bookIdData: [],
      bookData: {},
      BooktableData: [],
      coupon_id: "",
      isAbolish: false,
      bookSelectData: [],
      bookSelectIds: [],
      bookSelectName: [],
    };
  },
  mounted() {
    this.onSubmit();
    this.getVipList();
  },
  methods: {
    shFn() {
      if (this.isShShow == false) {
        let params = {
          status: 1,
        };
        http.put("admin/coupon/check/" + this.coupon_id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.onSubmit();
            this.shDialog = false;
            this.$message.success("审核成功");
          } else {
            this.shDialog = false;
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = {
          status: 2,
          remark: this.auditFailed,
        };
        http.put("admin/coupon/check/" + this.coupon_id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.onSubmit();
            this.shDialog = false;
            this.$message.success("审核成功");
          } else {
            this.shDialog = false;
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    shChange(e) {
      console.log(e, "e");
      if (e == 2) {
        this.isShShow = true;
      } else {
        this.isShShow = false;
      }
    },
    // 优惠券审核
    submitExamine(row) {
      this.shDialog = true;
      this.coupon_id = row.id;
      console.log(row, "row");
      // if (row.status == 0) {
      //   http.put("admin/coupon/check/" + row.id).then((res) => {
      //     if (res.data.status_code == 200) {
      //       this.onSubmit();
      //       this.$message.success("优惠券已废止");
      //     } else {
      //       return false;
      //     }
      //   });
      // } else {
      // }
    },
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.onSubmit();
    },
    couponStateChange(e) {
      console.log(e, "e");
      let params = {
        status: e,
        page: this.coupon_use_detail_page.index,
        page_size: this.coupon_use_detail_page.size,
        id: this.coupon_id,
      };
      http.get("admin/coupon/coupon_use_info", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.couponData = res.data.data.coupons;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看领取详情
    getUseDetail(row) {
      this.userDetailDialog = true;
      this.coupon_id = row.id;
      let params = {
        status: row.status,
        page: this.coupon_use_detail_page.index,
        page_size: this.coupon_use_detail_page.size,
        id: row.id,
      };
      http.get("admin/coupon/coupon_use_info", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.useTableData = res.data.data.use_info;
          this.couponData = res.data.data.coupons;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 分页导航
    handleBookPageChange(val) {
      console.log(val);
      this.bookSelectData = val;
      this.bookCurrentPage = val;
      this.getBookList();
    },
    cancelSelectBook() {
      this.bookDialog = false;
    },
    okSelectBook() {
      for (let i = 0; i < this.bookSelectData.length; i++) {
        this.bookSelectIds.push(this.bookSelectData[i].id);
        this.bookSelectName.push(this.bookSelectData[i].title);
      }
      this.bookDatas = this.bookSelectName;
      this.bookDialog = false;
    },
    // 估计搜索
    searchBook() {},
    onSubmit() {
      let that = this;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        status: that.formInline.status,
        coupon_type: 1,
        show_unchenked: 0,
      };
      http.get("admin/coupon/list", { params }).then((res) => {
        if (res.data.status_code == 200) {
          that.tableData = res.data.data.data;
          that.currentPage = res.data.data.current_page;
          that.totalPages = res.data.data.total;
          that.pageTotal = that.totalPages * that.page_size;
          that.loading = false;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 添加古籍
    addBook() {
      this.bookDialog = true;
    },
    handleSelectionChange(val) {
      console.log(val);
      this.bookSelectData = val;
    },

    // 古籍列表
    getBookList() {
      let params = {
        page_size: this.book_page_size,
        page: this.bookCurrentPage,
        title: this.bookData.title,
      };
      if (this.bookData.type == 3) {
        http
          .get("admin/admin_books/wq_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = res.data.data.current_page;
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.totalPages * this.page_size;
              console.log(this.BooktableData, "this.BooktableData");
              //console.log(data);
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].name;
              //   }
              //   //console.log(data);
              //   this.options[0].children = data;
              // }
            }
          });
      } else if (this.bookData.type == 1) {
        http
          .get("admin/admin_books/zk_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = res.data.data.current_page;
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.totalPages * this.page_size;
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].title;
              //   }
              //   this.options[1].children = data;
              // }
            }
          });
      } else if (this.bookData.type == 2) {
        http
          .get("admin/admin_books/yw_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = res.data.data.current_page;
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.totalPages * this.page_size;
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].name;
              //   }
              //   this.options[2].children = data;
              // }
            }
          });
      } else {
        return false;
      }
    },
    addCoupon() {
      this.centerDialogVisible = true;
      this.bookDatas = "";
      this.form = {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vipType: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      };
    },
    // 优惠券详情
    blurs(e) {
      //console.log(e);
      this.bookIdData = e;
    },
    detail(row) {
      this.coupon_id = row.id;
      this.form1 = {
        title: row.title, //优惠券标题
        goods_type: row.goods_type, //优惠券类型
        vipType: row.vipType, //会员类型
        book_ids: row.book_ids, //古籍ID
        favourable_type: row.favourable_type, //优惠方式
        satisfy: row.satisfy, //优惠方式为满减时-满
        amount: row.amount, //优惠方式为满减时-减
        discount: row.discount, //优惠方式为折扣时
        number: row.number, //发放数量
        user_type: row.user_type, //用户类型
        limit: row.limit, //每人限量
        can_add: row.can_add, //是否叠加
        validity: row.validity, //领取后有效期
        remark: row.remark, //备注
        is_exchange: 2,
      };
      this.changeDialogVisible = true;
      // http.get("admin/coupon/info/" + row.id).then((res) => {
      //   if (res.data.status_code == 200) {
      //     //console.log(res.data.data, "data");
      //     this.formData = res.data.data.data;
      //     console.log(this.formData, "form");
      //     if (this.form1.favourable_type == 1) {
      //       this.preferentialMethodNumber = 1;
      //     } else if (this.form1.favourable_type == 2) {
      //       this.preferentialMethodNumber = 2;
      //     } else {
      //       this.preferentialMethodNumber = 3;
      //     }
      //     if (this.form1.goods_type == 2) {
      //       this.vipTypeNumber = 2;
      //     }
      //   }
      // });
      // //console.log(row);
      // this.form = row;
      // this.centerDialogVisible = !this.centerDialogVisible;
    },
    // 编辑优惠券
    saveCoupon(formName) {
      console.log(this.form1, "form1");
      this.form1.book_ids = [];
      for (let i = 0; i < this.bookIdData.length; i++) {
        this.form1.book_ids.push(
          this.bookIdData[i].toString().replace(",", ":")
        );
      }
      this.form1.book_ids = this.form1.book_ids.toString();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http
            .put("admin/coupon/edit/" + this.coupon_id, this.form1)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("保存成功");
                this.changeDialogVisible = false;
                this.onSubmit();
                //console.log(res.data.data, "data");
              }
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增优惠券
    nBuildCoupon(formName) {
      this.form.book_ids = [];
      this.form.book_ids = this.bookSelectIds.toString();
      //console.log(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http.post("admin/coupon/add", this.form).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("新增成功");
              this.centerDialogVisible = false;
              this.onSubmit();
              //console.log(res.data.data, "data");
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 废止优惠券
    abolish(row) {
      this.abolishDialog = true;
      this.isAbolish = true;
      this.coupon_id = row.id;
    },
    // 废止领取详情中优惠券
    abolishCoupon(row) {
      this.abolishDialog = true;
      this.isAbolish = false;
      this.coupon_id = row.coupon_id;
    },
    // 确认是否废止
    abolishFn() {
      if (this.isAbolish == true) {
        http.put("admin/coupon/fz/" + this.coupon_id).then((res) => {
          if (res.data.status_code == 200) {
            this.abolishDialog = false;
            this.onSubmit();
            this.$message.success("优惠券已废止");
          } else {
            return false;
          }
        });
      } else {
        http
          .put("admin/coupon/coupon_user_fz/" + this.coupon_id)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.abolishDialog = false;
              this.getUseDetail();
              this.$message.success("优惠券已废止");
            } else {
              return false;
            }
          });
      }
    },
    // 关闭优惠券
    close(row) {
      this.closeDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否关闭
    closeFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.closeDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已关闭");
        } else {
          this.closeDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开优惠券
    open(row) {
      this.openDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否打开
    openFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.openDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已打开");
        } else {
          this.openDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 删除优惠券
    del(row) {
      this.coupon_id = row.id;
      this.delDialog = true;
    },
    delFn() {
      http.delete("admin/coupon/delete/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.delDialog = false;
          this.onSubmit();
          this.currentPage = 1;
          this.$message.success("删除成功");
        } else {
          this.delDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    //选择优惠券类型
    selectCouponType(e) {
      if (e == 1) {
        this.vipTypeNumber = 1;
      } else {
        this.vipTypeNumber = 2;
        this.getBookList();
      }
    },
    // 选择优惠方式
    selectpreferentialMethod(e) {
      if (e == 1) {
        this.preferentialMethodNumber = 1;
      } else if (e == 2) {
        this.preferentialMethodNumber = 2;
      } else if (e == 3) {
        this.preferentialMethodNumber = 3;
      }
    },
    // 获取vip商品类型列表
    getVipList() {
      http.get("admin/coupon/vip_goods_list").then((res) => {
        if (res.data.status_code == 200) {
          this.vipList = res.data.data;
        }
      });
    },
    //类型转换
    goodsType(type) {
      if (type == 1) {
        return "vip";
      } else if (type == 2) {
        return "古籍";
      }
    },
    youhuifangshi(row) {
      console.log(row);
      if (row.favourable_type == 1) {
        return "满" + row.satisfy + " " + "减" + row.amount;
      }
      if (row.favourable_type == 2) {
        return row.discount + "折";
      }
      if (row.favourable_type == 3) {
        return "减" + row.amount;
      }
    },
    //审核状态
    status(type) {
      if (type == 1) {
        return "审核通过";
      } else if (type == 2) {
        return "审核失败";
      } else if (type == 0) {
        return "待审核";
      }
    },
    // 使用状态
    useStatus(type) {
      if (type == 1) {
        return "正常";
      } else if (type == 2) {
        return "关闭";
      } else if (type == 3) {
        return "废止";
      }
    },
    // 领取详情使用状态
    useDetailStatus(type) {
      if (type == 1) {
        return "未使用";
      } else if (type == 2) {
        return "已使用";
      } else if (type == 3) {
        return "已过期";
      } else if (type == 4) {
        return "已废止";
      }
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>

<style scoped>
.couponBox {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}
.couponSearch {
  width: 100%;
  height: 60px;
}
.couponTitle {
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.title {
  float: left;
  font-size: 22px;
  font-weight: bold;
}
.button {
  float: right;
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.couponStateBox {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.couponState {
  display: flex;
  align-items: center;
}
</style>
